(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product-multi-images"] && !Shopify.designMode) return;
  try {
    class CardProductMultiImage extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const prev = this.querySelector('.previous-image')
        const next = this.querySelector('.next-image')

        const navClicked = (e) => {
            const element = e.target
            let delta = 1

            if (element.classList.contains('previous-image')) delta = -1

            const allImages = this.querySelectorAll('img')
            const parentElement = allImages[0].parentElement.parentElement
            const max = parseInt(parentElement.dataset.images)
            const currentImage = parseInt(parentElement.dataset.current)
            let newActiveImage = currentImage + delta

            if (newActiveImage <= 0) {
                newActiveImage = max
            } else if (newActiveImage > max) {
                newActiveImage = 1
            }

            allImages.forEach((image) => {
                image.classList.add('hidden')
                image.classList.remove('fade')

                if (parseInt(image.dataset.id) === newActiveImage) {
                    image.classList.remove('hidden')
                }
            })


            parentElement.dataset.current = newActiveImage
        }

        prev.addEventListener('click', navClicked)
        next.addEventListener('click', navClicked)
    }

    disconnectedCallback() {
        prev.removeEventListener('click', navClicked)
        next.removeEventListener('click', navClicked)
    }
}

if (!customElements.get('card-product-multi-image')) {
    customElements.define('card-product-multi-image', CardProductMultiImage);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["linked-products"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const variantNameDisplay = document.getElementById('variant-name-display');
  const productContainers = document.querySelectorAll('.product-image-container[data-variant-name]');
  const originalVariantName = variantNameDisplay ? variantNameDisplay.textContent : '';

  productContainers.forEach(container => {
    const variantName = container.getAttribute('data-variant-name');
    
    if (variantName && variantNameDisplay) {
      container.addEventListener('mouseenter', function() {
        variantNameDisplay.textContent = variantName;
      });
      
      container.addEventListener('mouseleave', function() {
        variantNameDisplay.textContent = originalVariantName;
      });
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
